import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';

function usePageScrollTo(isDisabled = false) {
  const routerRef = useRef(useRouter());
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!scrollRef.current || isDisabled) {
      return;
    }

    const scrollPaddingTopWithoutPx = document.documentElement.style.scrollPaddingTop.replace('px', '');
    const scrollPaddingTop = parseInt(scrollPaddingTopWithoutPx, 10);
    const top = scrollRef.current.offsetTop - scrollPaddingTop;

    const handleRouteChangeStop = () => {
      document.documentElement.style.scrollBehavior = 'smooth';
      window.scrollTo({ top });
    };

    const router = routerRef.current;

    router.events.on('routeChangeComplete', handleRouteChangeStop);

    handleRouteChangeStop();

    return () => {
      router.events.off('routeChangeComplete', handleRouteChangeStop);
    };
  }, [isDisabled]);

  return [scrollRef];
}

export default usePageScrollTo;
